import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Inline} from '@travel-frontend/core';
import {IconChevronTop, IconChevronBottom} from '@travel-frontend/icons';
import {Button, Flex, HeadlineSmall} from '@travel-frontend/ui-components';

import {Trigger} from '@/components/Collapsible/components/Trigger';

type Props = React.PropsWithChildren<{
  isOpen: boolean;
  isCollapsible?: boolean;
  onToggleClick: () => void;
  headline?: React.ReactNode;
  className?: string;
  triggerText?: string;
}>;

export const Headline = styled(
  ({
    isOpen,
    isCollapsible,
    onToggleClick,
    className,
    children,
    triggerText,
  }: Props) => {
    if (isCollapsible) {
      return (
        <Trigger asChild className={className}>
          <Button
            category="tertiary"
            variant="interaction"
            onClick={onToggleClick}
            fullWidth
            icon={
              <Inline space="4px" alignY="center">
                {triggerText}
                {isOpen ? <IconChevronTop /> : <IconChevronBottom />}
              </Inline>
            }
            iconPosition="right"
          >
            <Flex
              direction="row"
              spacing="8px"
              justifyContent="space-between"
              alignItems="center"
            >
              <HeadlineSmall>
                <Flex spacing="8px" direction="row" data-testid="caption">
                  {children}
                </Flex>
              </HeadlineSmall>
            </Flex>
          </Button>
        </Trigger>
      );
    }

    return (
      <Flex
        direction="row"
        spacing="8px"
        justifyContent="space-between"
        alignItems="center"
        className={className}
      >
        <HeadlineSmall>
          <Flex spacing="8px" direction="row" data-testid="caption">
            {children}
          </Flex>
        </HeadlineSmall>
      </Flex>
    );
  }
)(({isCollapsible, isOpen, theme}) => {
  const open = isCollapsible ? isOpen : true;

  return css`
    transition: margin-bottom 0.2s ease-out;
    margin: 0;
    ${theme.spacing('marginBottom', open ? '8px' : 0)}

    [data-testid^="IconChevron"] {
      width: 28px;
      height: 28px;
    }
  `;
});
